export function articleNav() {
    const parent = document.querySelector(".single-article");
    const pageNavOpener = parent.querySelector(".mobile-menu-opener");
    const pageNav = parent.querySelector(".single-article .page-nav-links");
    const pageNavHolder = parent.querySelector(".single-article .page-nav");
    const headings = parent.querySelectorAll("h1, h2, h3, h4, h5, h6");
    const header = document.querySelector(".header");
    const headerHeight = header ? header.offsetHeight : 0;
    if (!pageNav.classList.contains("non-automatically")) {
        headings.forEach(heading => {
            if (heading.id) {
                heading.classList.add("anchor-title");
                const li = document.createElement("li");
                const a = document.createElement("a");
                a.href = `#${heading.id}`;
                a.textContent = heading.textContent;
                li.appendChild(a);
                pageNav.appendChild(li);
            }
        });
    }

    const pageNavLink = document.querySelectorAll(".page-nav-links a");
    if (!pageNavLink.length) {
        pageNavHolder.remove();
    }
    pageNavLink.forEach(link => {
        link.addEventListener("click", function (event) {
            event.preventDefault();

            const href = this.getAttribute('href')
            if (href.startsWith('#')) {
                history.pushState(null, '', href);
            }
            const targetId = this.getAttribute("href").substring(1);
            const targetElement = document.getElementById(targetId);

            if (targetElement) {
                const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - headerHeight - 20;

                window.scrollTo({
                    top: targetPosition,
                    behavior: "smooth"
                });
            }
        });
    });
    const hash = window.location.hash.substring(1);
    if (hash) {
        const targetElement = document.getElementById(hash);
        if (targetElement) {
            setTimeout(() => {
                const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - headerHeight - 20;
                window.scrollTo({
                    top: targetPosition,
                    behavior: "smooth"
                });
            }, 400);
        }
    }

    const stickyArea = document.querySelector(".single-article");
    const stickyNavItem = document.querySelectorAll('.page-nav-links li');
    const sections = document.querySelectorAll('.single-article .anchor-title');
    let scrollTop;
    const topIndent = 20;

    function activeLinkOnScroll() {
        if (window.innerWidth > 1199) {
            scrollTop = window.scrollY;
            const stickyAreaHeight = stickyArea.offsetHeight;
            const stickyAreaTop = stickyArea.getBoundingClientRect().top + scrollTop;
            const stickyAreaBottom = stickyAreaHeight + stickyAreaTop - headerHeight + topIndent;

            if (scrollTop > stickyAreaTop - headerHeight - topIndent && scrollTop < stickyAreaBottom - headerHeight) {
                stickyArea.classList.add('has-fixed-child');
            } else if (scrollTop > stickyAreaBottom - headerHeight) {
                stickyArea.classList.remove('has-fixed-child');
            } else {
                sections.forEach(section => {
                    section.classList.remove('active');
                });
                stickyNavItem.forEach(item => {
                    item.classList.remove('active');
                });
                stickyArea.classList.remove('has-fixed-child');
            }

            if (stickyArea.classList.contains('has-fixed-child')) {
                sections.forEach(section => {
                    const itemOffsetTop = section.offsetTop;
                    if (scrollTop + headerHeight + topIndent >= itemOffsetTop) {
                        const attr = section.getAttribute("id");
                        if (!section.classList.contains("active")) {
                            section.classList.add('active');
                            const navLink = document.querySelector(`.page-nav-links a[href="#${attr}"]`);
                            if (navLink) {
                                navLink.parentElement.classList.add("active");
                                if (navLink.parentElement.previousElementSibling) {
                                    navLink.parentElement.previousElementSibling.classList.add("prev");
                                }
                            }
                        }
                    } else {
                        section.classList.remove('active');
                        const attr = section.getAttribute("id");
                        const navLink = document.querySelector(`.page-nav-links a[href="#${attr}"]`);
                        if (navLink) {
                            navLink.parentElement.classList.remove("active");
                            if (navLink.parentElement.previousElementSibling) {
                                navLink.parentElement.previousElementSibling.classList.remove("prev");
                            }
                        }
                    }
                });
            }
        } else {
            stickyArea.classList.remove('has-fixed-child');
            stickyNavItem.forEach(item => {
                item.classList.remove('active', 'prev');
            });
        }
    }

    function menuSticky() {
        scrollTop = window.scrollY;
        let navHeight = pageNavHolder.clientHeight;
        let parentTop = parent.offsetTop;
        let parentHeight = parent.clientHeight;
        let parentLeft = parent.getBoundingClientRect().left;
        let title = document.querySelector(".single-article header h1,.single-article header .h1");
        let titleTop = title.offsetTop;
        let titleStyle = window.getComputedStyle(title);
        let titleHeight = title.offsetHeight + parseFloat(titleStyle.marginBottom);
        if (window.innerWidth >= 1440) {
            pageNavHolder.style.position = "absolute";
            pageNavHolder.style.top = titleTop + titleHeight + "px";
            pageNavHolder.style.left = "0";
            pageNavHolder.style.bottom = "auto";
            if (scrollTop - headerHeight + 38 > titleTop + titleHeight && navHeight < window.innerHeight - headerHeight) {
                pageNavHolder.style.position = "fixed"
                pageNavHolder.style.left = parentLeft + "px";
                pageNavHolder.style.top = headerHeight + 38 + "px";
                pageNavHolder.style.bottom = "auto";
            }
            if (scrollTop - headerHeight + navHeight + 38 > parentTop + parentHeight && navHeight < window.innerHeight - headerHeight) {
                pageNavHolder.style.position = "absolute"
                pageNavHolder.style.left = "0";
                pageNavHolder.style.top = "auto";
                pageNavHolder.style.bottom = "0";
            }
        } else {
            pageNavHolder.removeAttribute("style");
        }
    }

    window.addEventListener("load", function () {
        activeLinkOnScroll();
        menuSticky();
    });
    window.addEventListener("scroll", function () {
        activeLinkOnScroll();
        menuSticky();
    });
    window.addEventListener("resize", function () {
        activeLinkOnScroll();
        menuSticky();
    });

    function slideUp(element, duration = 400) {
        element.style.height = element.offsetHeight + 'px';
        element.style.transition = `height ${duration}ms, padding ${duration}ms, margin ${duration}ms`;
        element.offsetHeight;

        element.style.overflow = 'hidden';
        element.style.height = 0;
        element.style.paddingTop = 0;
        element.style.paddingBottom = 0;
        element.style.marginTop = 0;
        element.style.marginBottom = 0;

        setTimeout(() => {
            element.style.display = 'none';
            element.style.removeProperty('height');
            element.style.removeProperty('padding-top');
            element.style.removeProperty('padding-bottom');
            element.style.removeProperty('margin-top');
            element.style.removeProperty('margin-bottom');
            element.style.removeProperty('overflow');
            element.style.removeProperty('transition');
        }, duration);
    }

    function slideDown(element, duration = 400) {
        element.style.removeProperty('display');
        let display = window.getComputedStyle(element).display;
        if (display === 'none') display = 'flex';
        element.style.display = display;

        let height = element.offsetHeight;
        element.style.height = 0;
        element.style.paddingTop = 0;
        element.style.paddingBottom = 0;
        element.style.marginTop = 0;
        element.style.marginBottom = 0;
        element.offsetHeight;

        element.style.transition = `height ${duration}ms, padding ${duration}ms, margin ${duration}ms`;
        element.style.overflow = 'hidden';
        element.style.height = height + 'px';
        element.style.removeProperty('padding-top');
        element.style.removeProperty('padding-bottom');
        element.style.removeProperty('margin-top');
        element.style.removeProperty('margin-bottom');

        setTimeout(() => {
            element.style.removeProperty('height');
            element.style.removeProperty('overflow');
            element.style.removeProperty('transition');
        }, duration);
    }

    function slideToggle(element, duration = 400) {
        const display = window.getComputedStyle(element).display;
        if (display === 'none') {
            slideDown(element, duration);
            pageNavOpener.classList.add('active');
        } else {
            slideUp(element, duration);
            pageNavOpener.classList.remove('active');
        }
    }


    pageNavOpener.addEventListener('click', function (e) {
        e.preventDefault();
        slideToggle(pageNav, 500);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/articleNav.js